{
  "DarkMode_Switch_Title": "Dark Mode",
  "DarkMode_SwitchLight_Title": "Light Mode",
  "NAME": "DarkMode"
}